export default class InsuranceHistoryEntry {
  tsdNo: number;
  akaName: string;
  year: number;
  annualPay: number;

  health: number;
  employeeHealth: number;
  companyHealth: number;

  dental: number;
  employeeDental: number;
  companyDental: number;

  vision: number;
  employeeVision: number;
  companyVision: number;

  life: number;
  employeeLife: number;
  companyLife: number;

  disability: number;
  employeeDisability: number;
  companyDisability: number;

  total: number;
  employeeTotal: number;
  companyTotal: number;
}



// WEBPACK FOOTER //
// ./src/models/personnel/InsuranceHistoryEntry.ts